<template>
    <b-modal ref="profile_modal"
             size="sm"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">

					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="panel-content mb-0">
                            <div class="user_auth">
                                <form class="user" autocomplete="off">
                                    <div class="form-group">
                                        <label class="form-label" for="input-live-feedback_usernameglovo">
                                            {{__t('GLOVO_PORTAL_CREDENTIALS')}}
                                        </label>
                                        <b-form-input
                                            id="input-live-feedback_usernameglovo11"
                                            v-model="user_form.username"
                                            autocomplete="off"
                                            autocorrect="off"
                                            autocapitalize="off"
                                            spellcheck="false"
                                            class="form-control form-control-use"
                                         >
                                        </b-form-input>
                                    </div>

                                    <div class="form-group mt-3">
                                        <b-form-input
                                            :state="userpass_state"
                                            id="user_pass_glovo"
                                            autocomplete="off"
                                            autocorrect="off"
                                            autocapitalize="off"
                                            spellcheck="false"
                                            :type=field_type.pass
                                            v-model="user_form.password" class="form-control form-control-user"
                                          ></b-form-input>

                                        <b-form-invalid-feedback id="user_pass_glovo">
                                            Минимум 6 символов
                                        </b-form-invalid-feedback>
                                    </div>

                                    <div class="auth_type">
                                        <yes_no
                                            key="IS_NEW_PORTAL"
                                            title="IS_NEW_PORTAL"
                                            v-model="user_form.is_new_portal"
                                        >
                                        </yes_no>
                                    </div>


                                    <div class="form-group mt-5 pt-5">
                                        <b-button class="btn btn-success btn-user btn-block" v-on:click="save_settings">
                                            {{__t('SAVE')}}
                                        </b-button>

                                        <b-button class="btn-warning btn-block" v-on:click="otp_auth" v-if="user_form.is_new_portal && user_form.id > 0">
                                            {{__t('OTP_KEY')}}
                                        </b-button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <ext_otp_code :ext_id="user_form.id"></ext_otp_code>
            </div>
        </template>
    </b-modal>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import Yes_no from "../../../sys/radio/yes_no.vue";
import ext_otp_code from "./ext_otp_code.vue";

const {mapFields} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
});

export default {
    name: "external_glovo",
    components: {Yes_no,ext_otp_code},
    props : {
        modal_position : {
            type : String,
            default : "left"
        },
    },
    data() {
        return  {
            is_show_modal : false,
            is_load : false,
            is_otp_step : false,
            field_type: {
                pass: "password",
            },
            user_form : {
                id : 0,
                username: "",
                password: "",
                is_new_portal : false,
            },
        }
    },
    created() {
        EventBus.$on("glovo_user",this.work_click);
    },
    methods : {

        close_modal() {
            this.close()
        },
        close() {
            this.is_show_modal = false;
        },

        work_click() {
            this.load_current_settings();
            this.is_show_modal = true;
        },

        async load_current_settings()
        {
            agr_api.get('/aggregators/glovo/glovo_auth').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.user_form = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
            });
        },

        async save_settings () {
            _core.showloading();

            agr_api.post('/aggregators/glovo/glovo_auth',this.user_form).then(({data}) => {
                this.is_load = false;
                _core.hideloading();
                this.close();

            }).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async otp_auth() {
            _core.showloading();
            agr_api.get('/aggregators/glovo/' +this.user_form.id +'/otp_auth').then(({data}) => {
                EventBus.$emit('glovo_otp');
                _core.hideloading();
            }).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {

        ...mapFields([
            'user',
            'module'
        ]),

        userpass_state() {
            return this.user_form.password.length > 3;
        },

        can_work () {
            return this.userpass_state;
        },

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-sm";
            }

            return "modal-dialog-right modal-sm";
        },
    }
}
</script>

<style scoped>

</style>
